import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import { ToolbarButton } from "../ToolbarButton/index.js";
const ToggleButton = ({
  Icon,
  label,
  onClick,
  dataHook,
  tooltip,
  active,
  disabled,
  setRef
}) => {
  const { isMobile } = useContext(RicosContext) || {};
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      ref: setRef,
      isMobile,
      active,
      tooltip,
      disabled,
      onClick,
      Icon,
      label,
      dataHook
    }
  );
};
var ToggleButton_default = ToggleButton;
export {
  ToggleButton_default as default
};
//# sourceMappingURL=ToggleButton.js.map
